export class Stackla {
    el;
    constructor(el) {
        this.el = el;
        if (window.addEventListener)
            window.addEventListener('load', Stackla.downloadJSAtOnload, false);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        else if (window.attachEvent)
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.attachEvent('onload', Stackla.downloadJSAtOnload);
        else
            window.onload = Stackla.downloadJSAtOnload;
    }
    static downloadJSAtOnload() {
        const element = document.createElement('script');
        element.src = '//assetscdn.stackla.com/media/js/widget/fluid-embed.js';
        element.id = 'stackla-widget-js';
        document.body.appendChild(element);
    }
}
